<template>
  <a-modal
    title="请指定计划版本"
    :width="400"
    :visible="visible"
    :maskClosable="false"
    okText="确认"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="计划版本">
        <global-select
          v-decorator="['planVersion', { rules: [{ required: true, message: '请输入计划版本' }] }]"
          requestApi="/scp/scpSopMpsPlans/versionBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="planVersion"
          :allowClear="false"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { apiScpScSafetyStockFactorRecalculate } from '@/api/scp/safety-stock/safety-stock-coefficient'
// 表单字段
export default {
  props: {},
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      labelCol: {
        xs: { span: 12 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      // 表单校验
      form: this.$form.createForm(this)
    }
  },
  created () {},
  methods: {
    show () {
      this.visible = true
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
      this.confirmLoading = false
    },
    // 保存
    confirm () {
      this.confirmLoading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = this.form.getFieldsValue()
          apiScpScSafetyStockFactorRecalculate(params.planVersion).then(response => {
            if (response.code === 200) {
              this.$message.success('保存成功')
              // 调用外部刷新列表方法
              this.$emit('handle-success')
              // 刷新表单
              this.reset()
              // 关闭本组件
              this.visible = false
              this.confirmLoading = false
            } else {
              this.$message.error(response.msg)
              this.confirmLoading = false
            }
          })
        } else {
          this.confirmLoading = false
        }
      });
    },
    // 表单重置
    reset () {
      this.form.resetFields()
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  height: 120px;
  // overflow-y: scroll;
}
/deep/.ant-select {
  width: 200px;
}
</style>
